import { CircularProgress, makeStyles, TextField } from "@material-ui/core";
import MuiAutocomplete from "@material-ui/lab/Autocomplete";
import { useEffect, useState } from "react";
import PuntoServicioAPI from "src/services/puntoDeServicio";

interface Opcion {
  id: string;
  nombre: string;
}

interface AutocompleteProps {
  className?: string;
  label: string;
  value: Opcion | null;
  setValue: (opcion: Opcion | null) => void;
  error?: boolean;
  disabled?: boolean;
  fiscalId?: string; // Nuevo: filtrar por fiscal seleccionado
}

const useStyles = makeStyles({
  option: { color: "#404040", fontWeight: "normal" },
});

const Autocomplete: React.FC<AutocompleteProps> = (
  props: AutocompleteProps
) => {
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState<Opcion[]>([]);
  const [value, setValue] = useState<Opcion | null>(props.value);
  const [input, setInput] = useState("");
  const classes = useStyles();

  useEffect(() => {
    if (props.value !== value) setValue(props.value);
  }, [props.value]);

  useEffect(() => {
    setInput(value ? value.nombre : "");
  }, [value]);

  useEffect(() => {
    if (input.length > 2 && !props.disabled) {
      setLoading(true);

      const fetcher = props.fiscalId
        ? PuntoServicioAPI.listarPorFiscal(props.fiscalId, input)
        : PuntoServicioAPI.listar(input);

      fetcher.then(
        (result) => {
          const datos = (result.data?.datos || []) as Array<any>;
          const opciones = datos.map((opcion: any) => ({
            id: opcion.ps_codigo ?? opcion.id ?? opcion.codigo,
            nombre: opcion.ps_nombre ?? opcion.nombre,
          }));
          setOptions(opciones as Array<unknown> as Array<Opcion>);
          setLoading(false);
        },
        () => {
          setOptions([]);
          setLoading(false);
        }
      );
    } else {
      setOptions([]);
      setLoading(false);
    }
  }, [input, props.fiscalId, props.disabled]);

  const updateValue = (value: Opcion | null) => {
    setValue(value);
    props.setValue(value ? value : null);
  };

  return (
    <MuiAutocomplete
      autoComplete
      className={props.className}
      classes={{ option: classes.option }}
      options={options}
      filterOptions={(options) => options}
      getOptionLabel={(option) => option.nombre}
      getOptionSelected={(option, value) => option.id === value.id}
      value={value}
      onChange={(event, value) => updateValue(value)}
      inputValue={input}
      onInputChange={(event, value, reason) => {
        (reason !== "reset" || (reason === "reset" && value !== "")) &&
          setInput(value);
      }}
      disabled={props.disabled}
      loading={loading}
      loadingText="Cargando..."
      noOptionsText="Sin coincidencias"
      renderInput={(params) => (
        <TextField
          {...params}
          label={props.label}
          variant="outlined"
          error={props.error}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default Autocomplete;
